import React from "react";
import { motion } from "framer-motion";
import JVAddressBox from "./JVAddressBox";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const JVCallToAction = () => (
  <section className="bg-[#101826] py-14 sm:py-20">
    <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
      <motion.h2
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={fadeUp}
        className="text-2xl font-bold text-white sm:text-4xl"
      >
        Ready To Partner With Us?
      </motion.h2>
      <motion.p
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={fadeUp}
        className="mt-3 text-sm text-slate-300 sm:mt-4 sm:text-lg"
      >
        No upfront cost. No listing fees. Just a fair partnership to sell your
        land fast.
      </motion.p>
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={fadeUp}
        className="mt-8 flex justify-center"
      >
        <JVAddressBox ctaLabel="Start My Joint Venture" idPrefix="jv-cta" />
      </motion.div>
    </div>
  </section>
);

export default JVCallToAction;
